export class Overlay {
  isFullWidth?: boolean = true; // Define si el contenido ocupa el 100% del ancho del overlay
  isFullHeight?: boolean = true; // Define si el contenido ocupa el 100% de la altura del overlay
  isButtonCloseVisible?: boolean = true; // Define si es visible el botón superior derecho para cerrar
  doesClickingOutsideContentClose?: boolean = true; // Define si se cierra el overlay al hacer click fuera de contenido
  fixedContentHeight?: number; // Definir altura de contenido fija
  EscapeClosesDialog?:boolean = true; //Define si la tecla ESC puede cerrar el diálogo
}
